import type { ReactNode } from 'react'

import { TabsContent } from '@/components/ui/tabs'
import type { FillStep } from './fillSteps'

interface FillStepPanelProps {
  value: FillStep
  active: boolean
  children: ReactNode
}

/** Kept mounted while another tab shows, so its edits and open rosters survive the switch. */
export function FillStepPanel({ value, active, children }: FillStepPanelProps) {
  return (
    // forceMount leaves `hidden` off, so it is set here to keep the other tabs out of view and out of reach.
    <TabsContent value={value} forceMount hidden={!active} className="flex flex-col gap-6">
      {children}
    </TabsContent>
  )
}
